// Hooks
import { useEffect, useState } from 'react';

// Components
import Button from '../Button/Button';
import Modal from '../Modal/Modal';

// Data utils
import { nativeShare } from '../../helpers/nativeShare';
import getDownloadFormData from '../../utils/data/getDownloadFormData';
import getShareFormData from '../../utils/data/getShareFormData';

const SummaryBlockSection = (props) => {
  const { id, title, list, scrollRefs, scrollMargin, handleScroll } = props;

  useEffect(() => {
    if (!scrollMargin) return false;
    const observer = new IntersectionObserver(handleScroll, scrollMargin);
    observer.observe(scrollRefs[id].current);
    return () => observer.disconnect();
  }, [scrollMargin]);

  return (
    <div className="SummaryBlock-section" ref={scrollRefs[id]} id={id}>
      {title && <h2 className="SummaryBlock-title">{title}</h2>}
      {list && (
        <ul className="SummaryBlock-list">
          {list.map((item, itemIndex) => (
            <li className="SummaryBlock-item" key={`SummaryBlock-item--${itemIndex}`}>
              <span className="SummaryBlock-bullet">
                <svg className="SummaryBlock-bulletIcon">
                  <use xlinkHref="#checkmark" />
                </svg>
              </span>
              <span className="SummaryBlock-label">{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

const SummaryBlock = (props) => {
  const { sections, buttons, scrollRefs, scrollMargin, handleScroll, playbookTitle } = props;

  const [downloadModalOpen, setDownloadModalOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const downloadFormData = getDownloadFormData(playbookTitle);
  const shareFormData = getShareFormData(playbookTitle);

  const shareButtonClickHandler = () => {
    const nativeShareCheck = nativeShare();
    if (!nativeShareCheck) setShareModalOpen(true);
  };

  const downloadButtonClickHandler = () => {
    setDownloadModalOpen(true);
  };

  return (
    <>
      <div className="SummaryBlock">
        <div className="SummaryBlock-inner">
          {sections.length >= 1 &&
            sections.map((section, sectionIndex) => (
              <SummaryBlockSection
                {...section}
                scrollRefs={scrollRefs}
                scrollMargin={scrollMargin}
                handleScroll={handleScroll}
                key={`SummaryBlock-section--${sectionIndex}`}
              />
            ))}
          {buttons && (
            <div className="SummaryBlock-buttonGroup">
              <>
                {buttons.map((button, buttonIndex) => (
                  <Button
                    label={button.label}
                    url={button.url}
                    modifier={button.modifier}
                    key={`SummaryBlock-button--${buttonIndex}`}
                    onClick={
                      button.type === 'share'
                        ? shareButtonClickHandler
                        : button.type === 'download'
                        ? downloadButtonClickHandler
                        : undefined
                    }
                  />
                ))}
              </>
            </div>
          )}
        </div>
      </div>
      <Modal open={downloadModalOpen} onClose={() => setDownloadModalOpen(false)} formData={downloadFormData} />
      <Modal open={shareModalOpen} onClose={() => setShareModalOpen(false)} formData={shareFormData} />
    </>
  );
};

export default SummaryBlock;
